var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('administration-offers-layout',{attrs:{"title":"Список стран","error-text":"Список стран не загружен","api-method":_vm.getEmployeesCountries,"is-country":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }